import { render, staticRenderFns } from "./SectionBreakType.vue?vue&type=template&id=259a5bac&"
import script from "./SectionBreakType.vue?vue&type=script&lang=js&"
export * from "./SectionBreakType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports